<div class="gridview" [ngClass]="{ 'paginated': paginated }">
    @if (!config.list || config.list.length == 0 || !config.table) {
        <div class="text-center vazio">
            @if (!config.emptyText.isHtml) {
                <p class="mb0">{{config.emptyText.value | translate}}</p>
            } @else {
                <p [innerHTML]="config.emptyText.value | translate"></p>
            }
        </div>
    } @else {
        <section class="d-flex flex-wrap striped hover">
            <header>
                @for (col of config.table.header; track col.value) {
                    @if (config.sort.enabled && col.sortName) {
                        <div (click)="sortTableBy(col.sortName)" [ngClass]="col.className" class="cursor-pointer">
                            <div [ngClass]="{ 'header-with-subtitle': col.subtitle }">
                                {{ col.value | translate }}
                                @if (col.subtitle) {
                                    <small>{{ col.subtitle | translate }}</small>
                                }
                            </div>

                            @if (config.sort.sortedBy !== col.sortName) {
                                <div class="not-active">
                                    <span><em class="fa fa-caret-up"></em></span>
                                    <span><em class="fa fa-caret-down"></em></span>
                                </div>
                            }
                            @else {
                                <span><em class="fa fa-caret-{{config.sort.isReverse ? 'down' : 'up'}}"></em></span>
                            }

                        </div>
                    } @else {
                        <div class="{{col.className}}" [ngClass]="{ 'header-with-subtitle': col.subtitle }">
                            {{ col.value | translate }}
                            @if (col.subtitle) {
                                <small>{{ col.subtitle | translate }}</small>
                            }
                        </div>
                    }
                }
            </header>
            <ng-scrollbar class="corpo" [ngClass]="config.table.bodyClassName">
                @for (item of config.list; track item; let itemIndex = $index) {
                    <div class="linha" [ngClass]="{ 'has-line-click': hasLineClick }" (click)="lineClick(item)">
                        @for (col of config.table.body; track col; let i = $index) {
                            <div class="col" [ngClass]="col.className">
                                @if (col.type === 'string') {
                                    <span [tooltip]="col.truncate ? item[col.value] : null">{{ item[col.value] }}</span>
                                }
                                @if (col.type === 'nullable') {
                                    <span>{{ item[col.value] || '-' }}</span>
                                }
                                @if (col.type === 'date') {
                                    <span>{{ item[col.value] | date:col.format }}</span>
                                }
                                @if (col.type === 'number') {
                                    <span>{{ item[col.value] | number:col.format }}</span>
                                }
                                @if (col.type === 'currency') {
                                    <span>{{ item[col.value] | currency:'R$' }}</span>
                                }
                                @if (col.type === 'negative-currency') {
                                    <span>{{ item[col.value] | currency: item[col.value] == 0 ? 'R$' : '-R$' }}</span>
                                }
                                @if (col.type === 'html' && item) {
                                    <ng-container *ngTemplateOutlet="getTemplate(col.templateName); context: {$implicit: item}"></ng-container>
                                }
                                @if (col.type === 'boolean' && item[col.value]) {
                                    <i-feather name="check"></i-feather>
                                }
                                @if (col.type === 'boolean' && !item[col.value]) {
                                    <i-feather name="x"></i-feather>
                                }
                            </div>
                        }
                        @if (config.actions.approve.enable || config.actions.edit.enable || config.actions.email.enable || config.actions.action.enable || config.actions.reject.enable || config.actions.remove.enable || config.icon) {
                            <div class="col icons" [ngClass]="config.hasSmallActions ? 'col-0-25' : 'col-0-5'">
                                @if (config.icon) {
                                    <i-feather [name]="config.icon.iconName" [tooltip]="config.icon.tooltipText | translate"></i-feather>
                                }
                                @if (config.actions.edit.enable && config.actions.edit.type === 'icon') {
                                    <i class="fa fa-1x fa-edit cursor-pointer mt-1" tooltip="{{ config.actions.edit.tooltipText ?? 'support.cotacoes.vendedores.atualizar.tooltip-perfil' | translate}}" (click)="edit($event, item)" [attr.disabled]="config.actions.edit.disabledCondition?.(item)"></i>
                                }
                                @if (config.actions.email.enable && config.actions.email.type === 'icon') {
                                    <i-feather name="mail" tooltip="{{ config.actions.email.tooltipText ?? 'support.cotacoes.vendedores.atualizar.tooltip-email' | translate}}" (click)="email($event, itemIndex, item)" [ngClass]="{ 'disabled': config.actions.email.disabledCondition?.(item) }"></i-feather>
                                }
                                @if (config.actions.action.enable && config.actions.action.type === 'icon') {
                                    <i-feather name="external-link" tooltip="{{ config.actions.action.tooltipText ?? 'support.cotacoes.vendedores.atualizar.tooltip-reload' | translate}}" (click)="action($event, itemIndex, item)"></i-feather>
                                }
                                @if (config.actions.approve.enable && config.actions.approve.type === 'icon') {
                                    <i-feather name="check" tooltip="{{ config.actions.approve.tooltipText ?? 'support.cotacoes.vendedores.atualizar.tooltip-approve' | translate}}" (click)="approve($event, item)"></i-feather>
                                }
                                @if (config.actions.reject.enable && config.actions.reject.type === 'icon') {
                                    <i-feather name="x" tooltip="{{ config.actions.reject.tooltipText ?? 'support.cotacoes.vendedores.atualizar.tooltip-reject' | translate}}" (click)="reject($event, item)"></i-feather>
                                }
                                @if (config.actions.remove.enable && config.actions.remove.type === 'icon') {
                                    <i class="fa fa-1x fa-trash cursor-pointer" tooltip="{{ config.actions.remove.tooltipText ??'support.cotacoes.vendedores.atualizar.tooltip-excluir' | translate}}" (click)="remove($event, itemIndex, item)" [attr.disabled]="config.actions.remove.disabledCondition?.(item)"></i>
                                }
                                @if (config.actions.edit.enable && config.actions.edit.type === 'button') {
                                    <button type="button" class="btn btn-primary btn-sm" [disabled]="config.actions.edit.disabledCondition?.(item)" (click)="edit($event, item)">{{ (config.actions.edit.labelText ?? 'elemento.generico-botao.editar') | translate}}</button>
                                }
                                @if (config.actions.remove.enable && config.actions.remove.type === 'button') {
                                    <button type="button" class="btn btn-light btn-sm" [disabled]="config.actions.remove.disabledCondition?.(item)" (click)="remove($event, itemIndex, item)">{{ (config.actions.remove.labelText ?? 'elemento.generico-botao.remover') | translate}}</button>
                                }
                            </div>
                        }
                    </div>
                }
            </ng-scrollbar>
            <footer>
                <div *ngIf="paginated" class="d-flex justify-content-end">
                    <mat-paginator
                        [showFirstLastButtons]="showFirstLastButtons"
                        [hidePageSize]="hidePageSize"
                        [length]="totalItems"
                        [pageSize]="pageSize"
                        [pageIndex]="pageIndex"
                        (page)="emitPageChange($event)">
                    </mat-paginator>
                </div>
            </footer>
        </section>
    }
</div>
